export const NUMERIC_FILTER = 101;
export const DATE_FILTER = 102;
export const CUSTOM_FILTER_GUID = '2fcada05-503b-45df-8290-41d36895a073';